export const 
    IMPORT_CANCEL               = 'IMPORT_CANCEL',
    IMPORT_FILE_UPLOAD_REQ      = 'IMPORT_FILE_UPLOAD_REQ',
    IMPORT_FILE_UPLOAD_SUCCESS  = 'IMPORT_FILE_UPLOAD_SUCCESS',
    IMPORT_FILE_UPLOAD_ERROR    = 'IMPORT_FILE_UPLOAD_ERROR',
    IMPORT_SET_MODE             = 'IMPORT_SET_MODE',
    IMPORT_PARCEL_SAVE_REQ      = 'IMPORT_PARCEL_SAVE_REQ',
    IMPORT_PARCEL_SAVE_PROGRESS = 'IMPORT_PARCEL_SAVE_PROGRESS',
    IMPORT_PARCEL_SAVE_SUCCESS  = 'IMPORT_PARCEL_SAVE_SUCCESS',
    IMPORT_PARCEL_SAVE_ERROR    = 'IMPORT_PARCEL_SAVE_ERROR'